

export class Node implements d3.SimulationNodeDatum {
  public N : number =  100;
  public SPECTRUM: string[]= [
    // "rgb(222,237,250)"
    "rgb(176,212,243)",
    "rgb(128,186,236)",
    "rgb(77,158,228)",
    "rgb(38,137,223)",
    "rgb(0,116,217)",
    "rgb(0,106,197)",
    "rgb(0,94,176)",
    "rgb(0,82,154)",
    "rgb(0,60,113)"
  ]

  // optional - defining optional implementation properties - required for relevant typing assistance
  index?: number;
  public x?: number;
  public y?: number;
  public vx?: number;
  public vy?: number;
  public fx?: number | null;
  public fy?: number | null;

  id: string;
  linkCount: number = 0;

  constructor(id) {
    this.id = id;
  }

  normal = () => {
    return Math.sqrt(this.linkCount / this.N);
  }

  get r() {
    return 50 * this.normal() + 10;
  }

  get fontSize() {
    return (30 * this.normal() + 10) + 'px';
  }

  get color():string {
    let index = Math.floor(this.SPECTRUM.length * this.normal());
    return this.SPECTRUM[index];    
  }
}
